<template>
  <div class="item-picker">
    <div class="item-picker__tables d-xl-flex flex-xl-row">
      <div class="item-picker__tables__table-wrapper shadow-sm">
        <h5 class="text-center">{{ unpickedTitle }}</h5>
        <b-form-input placeholder="Поиск..." v-model="searchLeft" />
        <b-table
          selectable
          select-mode="single"
          @row-selected="pickItem"
          :responsive="true"
          :items="filteredItems"
          :fields="displayableFields"
          hover
          borderless
          thead-class="d-none"
          class="item-picker__tables__table-wrapper__table left-table"
          tbody-tr-class="item-picker__tables__table-wrapper__table__row"
        />
      </div>
      <div class="item-picker__tables__table-wrapper shadow-sm">
        <h5 class="text-center">{{ pickedTitle }}</h5>
        <b-form-input placeholder="Поиск..." v-model="searchRight" />
        <b-table
          selectable
          select-mode="single"
          @row-selected="unpickItem"
          :responsive="true"
          :items="pickedItems"
          :fields="displayableFields"
          hover
          borderless
          thead-class="d-none"
          class="item-picker__tables__table-wrapper__table right-table"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { displayableFields } from "@/components/Tables/defaultFields";

export default {
  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    value: {
      type: Array,
      required: true,
      default: () => []
    },
    fields: {
      type: Array,
      require: true
    },
    unpickedTitle: {
      type: String,
      required: false,
      default: "Невыбранные"
    },
    pickedTitle: {
      type: String,
      required: false,
      default: "Выбранные"
    },
    displayTableHeaders: {
      type: Boolean,
      required: false,
      default: true
    },
    isMultiplySelect: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      searchLeft: "",
      searchRight: ""
    };
  },
  computed: {
    searchBy: ({ fields }) => fields.find(({ search }) => search === true),
    formatter: ({ searchBy }) =>
      searchBy !== undefined && typeof searchBy.formatter === "function"
        ? searchBy.formatter
        : value => value,
    filteredItems: ({ searchBy, formatter, items, searchLeft, value }) => {
      return items.filter(
        item =>
          !value.includes(item) &&
          formatter(item[searchBy.key], searchBy.key, item).includes(searchLeft)
      );
    },
    pickedItems: ({ searchBy, formatter, items, searchRight, value }) => {
      return items.filter(
        item =>
          value.includes(item) &&
          formatter(item[searchBy.key], searchBy.key, item).includes(
            searchRight
          )
      );
    },
    displayableFields: ({ fields }) => displayableFields(fields)
  },
  methods: {
    pickItem(items) {
      if (items.length > 0) {
        this.value.push(items[0]);
        this.$emit("input", this.value);
      }
    },
    unpickItem(items) {
      if (items.length > 0) {
        this.value.splice(this.value.indexOf(items[0]), 1);
        this.$emit("input", this.value);
      }
    }
  }
};
</script>

<style lang="scss">
.item-picker {
  &__tables {
    &__table-wrapper {
      flex: 1;
      border-radius: 0.25rem;
      padding: 5px;
      margin: 5px;
      &:first-child {
        background: rgba(#6c757d, 0.3);
      }
      &:last-child {
        background: rgba(#28a745, 0.3);
      }
      &__table {
        margin-bottom: 0;
        margin-top: 5px;
        & table {
          & tbody {
            & tr {
              border-radius: 0.25rem;
              display: block;
            }
          }
        }
        &__row {
          border-radius: 0.25rem;
        }
      }
      &.right-table {
      }

      &.left-table {
      }
    }
    &__controls {
    }
  }
}
</style>
